import React from "react";
import { useTranslation } from "react-i18next";
import "./PrintingDisclaimerModal.css";

const PrintingDisclaimerModal = ({ isOpen, onClose, onProceed }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="printing-disclaimer-modal-overlay">
      <div className="printing-disclaimer-modal">
        <div className="printing-disclaimer-header">
          <h3>{t("printing.disclaimer_title")}</h3>
        </div>

        <div className="printing-disclaimer-content">
          <p className="disclaimer-intro">{t("printing.disclaimer_intro")}</p>

          <ul className="disclaimer-list">
            <li>{t("printing.disclaimer_point_1")}</li>
            <li>{t("printing.disclaimer_point_2")}</li>
            <li>{t("printing.disclaimer_point_3")}</li>
            <li>{t("printing.disclaimer_point_4")}</li>
            <li>{t("printing.disclaimer_point_5")}</li>
          </ul>
        </div>

        <div className="printing-disclaimer-buttons">
          <button className="btn-modify" onClick={onClose}>
            {t("printing.go_back_and_modify")}
          </button>
          <button className="btn-proceed" onClick={onProceed}>
            {t("printing.proceed")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintingDisclaimerModal;
